import React from 'react';


class RuleListenForEvent extends React.Component {
    constructor(props) {
        super(props);

        this.displayValue = this.displayValue.bind(this);
        this.available = {
            'NEW_ORDER' : 'Send to customer when a new order is placed in your store',
            'CART_REMINDER' : 'Send to customers who add products to cart, but don’t complete their purchase',
            'NO_PURCHASE' : 'Send to customers who hasn\'t placed an order since last order',
            'BIRTHDAY' : 'Send to customers when they have a birthday',
        };
    }

    displayValue(value) {
        return this.available[value];
    }

    render() {
        if(this.props.onlyDescription) {
            return <li></li>;
        }
        return (
                <div className="list-group-item blue-grey-500">    
                    <div>{this.displayValue(this.props.rule.value)}</div>
                </div>
        );
    }

  
}

export default RuleListenForEvent;




// WEBPACK FOOTER //
// ./components/builder/RuleListenForEvent.js